define('TescoMobile_Algolia/js/isNew',['TescoMobile_Catalog/js/new-date'], function (newDate) {
  'use strict';

  return hit => {
    return newDate.isProductNew(hit === null || hit === void 0 ? void 0 : hit.tm_news_from_date, hit === null || hit === void 0 ? void 0 : hit.tm_news_to_date);
  };
});

